// Progressive input mask for North American phone numbers → "XXX-XXX-XXXX".
// Works for both typing and autofill: strips non-digits, caps at 10, and
// formats as the user goes. Pair every phone <TextField> with:
//   type="tel", inputProps={{ inputMode: "tel" }}
//   value={phone}
//   onChange={(e) => setPhone(formatPhoneInput(e.target.value))}
export function formatPhoneInput(raw: string): string {
  const digits = (raw || "").replace(/\D/g, "").slice(0, 10);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
}
